export const FireBaseConfig = {
  apiKey: "AIzaSyCP1eGJuMGPKTjK8BxayQh6jx569PTka4k",
  authDomain: "https://chicken-station--yigal-alon.firebaseio.com/",
  databaseURL: "https://chicken-station--yigal-alon.firebaseio.com/",
  projectId: "https://chicken-station--yigal-alon.firebaseio.com/",
  storageBucket: "chicken-station--yigal-alon.appspot.com",
  messagingSenderId: "272968731003"
};
